import { clientDetailsModel } from "./clientDetails.model";

export const addressModel = {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    // client: { ...clientDetailsModel },
  };
  